import type { ClassReducerState } from '@engage/classes/redux';

export const CLASSES_NAMESPACE = 'classes';

type ClassesSelectorState = {
  [CLASSES_NAMESPACE]: ClassReducerState;
};

export const getClasses = (state: ClassesSelectorState) => state[CLASSES_NAMESPACE];
